import { render } from "./QuestionObjectPhoneticTranscription.vue?vue&type=template&id=3e6ae20e&scoped=true"
import script from "./QuestionObjectPhoneticTranscription.vue?vue&type=script&lang=js"
export * from "./QuestionObjectPhoneticTranscription.vue?vue&type=script&lang=js"

import "@/css/components/question-object-phonetic-transcription.css?vue&type=style&index=0&id=3e6ae20e&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e6ae20e"]])

export default __exports__